import React from 'react';

const Kyc_Terms_conditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800 dark:text-gray-200">
      <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>

      <p className="mb-4">
        Welcome to our website. These terms and conditions outline the rules and regulations for the use of this site.
        By accessing this website, we assume you accept these terms and conditions in full. Do not continue to use this
        website if you do not agree to all the terms and conditions stated on this page.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Intellectual Property Rights</h2>
      <p className="mb-4">
        Other than the content you own, under these Terms, the website owner and/or its licensors own all the intellectual
        property rights and materials contained in this website. You are granted limited license only for purposes of
        viewing the material contained on this website.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Restrictions</h2>
      <p className="mb-4">
        You are specifically restricted from all of the following:
      </p>
      <ul className="list-disc ml-6 mb-4 space-y-1">
        <li>Publishing any website material in any media</li>
        <li>Selling, sublicensing, or commercializing any website material</li>
        <li>Publicly performing or showing any website material</li>
        <li>Using this website in any way that is damaging to the website</li>
        <li>Using this website contrary to applicable laws and regulations</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Limitation of Liability</h2>
      <p className="mb-4">
        In no event shall the website owner, nor any of its officers, directors, or employees, be held liable for anything
        arising out of or in any way connected with your use of this Website.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Governing Law & Jurisdiction</h2>
      <p className="mb-4">
        These Terms will be governed by and interpreted in accordance with the laws of your jurisdiction, and you submit
        to the non-exclusive jurisdiction of the state and federal courts located in your country for the resolution of any disputes.
      </p>

      <p className="mt-8 text-sm text-gray-500 dark:text-gray-400">
        Last updated: May 20, 2025
      </p>
    </div>
  );
};

export default Kyc_Terms_conditions;
